<template>
  <el-dialog title="Renovar Contrato de Aluguel" :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="700px">
    <el-form ref="form" :model="aluguelRenovacao" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10" style="margin-bottom:20px;">
        <el-col :span="6">
          <div><strong>Data Início</strong></div>
          <div v-if="this.aluguel.previsaoFim">{{ this.util.dataParaString(this.util.adicionarDias(this.aluguel.previsaoFim,1)) }}</div>
        </el-col>
        <el-col :span="12">
          <div><strong>Data Fim</strong></div>
          <div v-if="this.dataFim">{{ this.dataFim }}</div>
        </el-col>
        <el-col :span="6">
          <div><strong>Valor Atual</strong></div>
          <div>{{ util.formatarValor(this.aluguel.valor) }}</div>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item prop="duracao">
            <template slot="label">
              <strong>Duração</strong>
            </template>
            <el-input v-model="aluguelRenovacao.duracao" v-mask="'###'">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="reajuste">
            <template slot="label">
              <strong>Reajuste</strong>
            </template>
            <el-input v-model="aluguelRenovacao.reajuste" v-mask="'##'">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col>
          <el-form-item>
            <template slot="label">
              <strong style="font-size: 15px">
                Ajuste
              </strong>
            </template>
            <el-switch
              v-model="percentualReajusteIsSelecionado"
              inactive-text="Valor"
              active-text="Percentual"
              active-color="#008080"
              inactive-color="#008080"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="percentualReajusteIsSelecionado" :gutter="10">
        <el-col :span="6">
          <el-form-item>
            <el-input
              v-model="percentualRenovacao"
              @input="calcularNovoValor"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ util.formatarValor(this.valorRenovacao) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row v-else :gutter="10">
        <el-col :span="6">
          <el-form-item prop="valor">
            <el-input
              v-model="valorRenovacao"
              @input="calcularNovoPercentual"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="prepend">R$</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ util.formatarPercentual(this.percentualRenovacao) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="dataRescisao">
            <template slot="label">
              <strong>Cobrar multa se recisão antes</strong>
            </template>
            <el-date-picker
              v-model="aluguelRenovacao.dataRescisao"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="mesesMultaRescisao">
            <template slot="label">
              <strong>Equivalente a</strong>
            </template>
            <el-input
              v-model="aluguelRenovacao.mesesMultaRescisao"
              v-mask="'##'"
              @input="calcularMultaRescisao"
            >
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <template slot="label">
              <strong>Multa</strong>
            </template>
            <div class="el-input el-input--small">
              <money
                disabled
                v-model="aluguelRenovacao.multaRescisao"
                v-bind="money"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col>
          <el-form-item>
            <template slot="label">
              <strong style="font-size: 15px">
                Desconto por Pontualidade
              </strong>
            </template>
            <el-switch
              v-model="percentualPontualidadeIsSelecionado"
              inactive-text="Valor do Desconto"
              active-text="Percentual do Desconto"
              active-color="#008080"
              inactive-color="#008080"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="percentualPontualidadeIsSelecionado" :gutter="10">
        <el-col :span="6">
          <el-form-item prop="desconto">
            <el-input
              v-model="aluguelRenovacao.desconto"
              @input="calcularValorDescontoPontualidade"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ util.formatarValor(this.aluguelRenovacao.valorDesconto) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row v-else :gutter="10">
        <el-col :span="6">
          <el-form-item prop="valorDesconto">
            <el-input
              v-model="aluguelRenovacao.valorDesconto"
              @input="calcularPercentualDescontoPontualidade"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="prepend">R$</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-tag style="font-size: 14px">
            {{ util.formatarPercentual(this.aluguelRenovacao.desconto) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :md="6" :lg="8" :span="6">
          <el-form-item prop="diasDesconto">
            <template slot="label">
              <strong>Antecedência</strong>
            </template>
            <el-input
              auto-complete="off"
              v-model="aluguelRenovacao.diasDesconto"
              v-mask="'##'"
            >
              <template slot="append">
                dias
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="confirmarRenovarHandler" type="primary" size="small" round class="btn-box-shadow">Concluir</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapState } from "vuex";
import Util from "../../../util/funcoes.js";
import { Money } from "v-money";

export default {
  components: {
    Money
  },
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      aluguelRenovacao: { 
        id: 0,
        valor: 0,
        duracao: undefined,
        reajuste: undefined,
      
        dataRescisao: undefined,
        mesesMultaRescisao: undefined,
        multaRescisao: 0,

        desconto: this.aluguel.desconto,
        valorDesconto: this.aluguel.valorDesconto,
        diasDesconto: this.aluguel.diasDesconto
      },

      percentualReajusteIsSelecionado: false,
      percentualPontualidadeIsSelecionado: false,

      percentualRenovacao: 0,
      valorRenovacao: 0,

      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },

      dataFim: undefined,

      validacao: {
        duracao: [{ required: true, validator: this.validarDuracaoReajust }],
        reajuste: [{ required: true, validator: this.validarDuracaoReajust }],
        mesesMultaRescisao: [{ required: true }],
        dataRescisao: [{ required: true }]
      }
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    util() {
      return Util;
    }
  },
  watch:{
    'aluguelRenovacao.duracao'(newValue){
      if(!newValue || newValue <= 0){
        this.dataFim = undefined
      } else {
        let data = this.util.adicionarMeses(this.util.stringParaData(this.aluguel.previsaoFim), newValue)
        this.dataFim = this.util.dataParaString(data)
      }
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore",["renovarAluguel"]),

    iniciar() {
      this.valorRenovacao = this.aluguel.valor
    },

    confirmarRenovarHandler() {
      this.$confirm("Após a efetivação da renovação, o contrato terá uma nova duração e serão criados recibos conforme a quantidade de meses informados no campo de reajuste. Você tem certeza que deseja confirmar a renovação?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.renovar();
        });
		},

    renovar(){
      if(!this.valorRenovacao || parseFloat(this.valorRenovacao) <= 0){
        this.$message.info("Informe um valor acima de R$ 0,00.");
        return
      }

      let payload;
      this.aluguelRenovacao.valor = this.valorRenovacao
  
      this.$refs["form"].validate(valid => {
        if(valid) {
          payload = { 
            ...this.aluguelRenovacao,
            id: this.aluguel.id,
          }

          this.showLoading();
          this.renovarAluguel(payload)
            .then(resultado => {
              this.hideLoading();
              switch (resultado.status) {
                case "SUCESSO":
                  this.$message.success(resultado.mensagem);
                  this.fechar()
                  break;
                default:
                  this.$message.error(resultado.mensagem);
              }
            })
            .catch(() => {
              this.$message.error("Ocorreu um erro.");
              this.hideLoading();
            });
          } 
      });
    },

    calcularMultaRescisao() {
      this.aluguelRenovacao.multaRescisao = this.aluguelRenovacao.mesesMultaRescisao * this.valorRenovacao;
    },

    calcularNovoValor() {
      const novoValor = (this.aluguel.valor + (this.aluguel.valor * (this.percentualRenovacao/100))).toFixed(2);

      if(isFinite(novoValor)) {
        this.valorRenovacao = novoValor;
      } else {
        this.valorRenovacao = this.aluguel.valor;
      }

      this.calcularValorDescontoPontualidade();
      this.calcularMultaRescisao();
    },

    calcularNovoPercentual(){
      const novoPercentual = (((this.valorRenovacao - this.aluguel.valor) * 100)/this.aluguel.valor).toFixed(2);

      if(isFinite(novoPercentual)) {
        this.percentualRenovacao = novoPercentual;
      } else {
        this.percentualRenovacao = 0;
      }

      this.calcularValorDescontoPontualidade();
      this.calcularMultaRescisao();
    },

    calcularValorDescontoPontualidade() {
      if(this.valorRenovacao > 0) {
        const desconto = ((this.valorRenovacao * this.aluguelRenovacao.desconto)/100).toFixed(2);

        if(isFinite(desconto)) {
          this.aluguelRenovacao.valorDesconto = desconto;
        } else {
          this.aluguelRenovacao.valorDesconto = 0;
        }
      }
    },
    calcularPercentualDescontoPontualidade() {
      if(this.valorRenovacao > 0) {
        const percentual = ((this.aluguelRenovacao.valorDesconto * 100)/this.valorRenovacao).toFixed(2);

        if(isFinite(percentual)) {
          this.aluguelRenovacao.desconto = percentual;
        } else {
          this.aluguelRenovacao.desconto = 0;
        }
      }
    },

    validarSeparadorDecimal(event) {
      const textoDigitado = event.target.value;
      
      const textoComVirgulasTratadas = this.substituirTodaVirgulaPorPonto(textoDigitado);
      const textoComPontosTratados = this.removerTodosOsPontosDepoisDoPrimeiro(textoComVirgulasTratadas);

      const textoFinal = textoComPontosTratados;

      event.target.value = textoFinal;
    },

    validarInputNumerico(event) {
      const valorDigitado = event.key;
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
      const valorNaoEhPermitido = !valoresPermitidos.includes(valorDigitado);

      if(valorNaoEhPermitido) event.preventDefault();
    },

    substituirTodaVirgulaPorPonto(texto) {
      return texto.replace(/,/g, '.');
    },
    removerTodosOsPontosDepoisDoPrimeiro(texto) {
      return texto.replace(/(?<=\..*)\./g, '');
    },

    reset(){
      this.aluguelRenovacao = { 
        id: 0,
        valor: 0,
        duracao: undefined,
        reajuste: undefined,
      
        dataRescisao: undefined,
        mesesMultaRescisao: undefined,
        multaRescisao: 0,

        desconto: this.aluguel.desconto,
        valorDesconto: this.aluguel.valorDesconto,
        diasDesconto: this.aluguel.diasDesconto
      },
      this.percentualPontualidadeIsSelecionado = false;
      this.percentualReajusteIsSelecionado = false;

      this.percentualRenovacao = 0,

      this.dataFim = undefined
    },

    fechar() {
      this.reset();
      this.$emit('close');
    }, 
  }
}
</script>
